import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ReferralModalWrapper from '../../components/HistoryComps/ReferralsComps/ReferralModalWrapper';
import ShowAllReferralHistory from '../../components/HistoryComps/ReferralsComps/ShowAllReferralHistory';
import ReferralHistoryProvider from '../../contexts/ReferralHistoryProvider';

const Referrals = () => {
  // rendering referrals history page component here
  return (
    <>
      <PageTitle title='Referral History' />

      <ReferralHistoryProvider>
        <ShowAllReferralHistory />
        <ReferralModalWrapper />
      </ReferralHistoryProvider>
    </>
  );
};

export default Referrals;
